import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "game-list" }
const _hoisted_2 = { class: "text-capitalize-first" }
const _hoisted_3 = { class: "games-wrapper" }

import GameIcon from "@/components/games/GameIcon.vue";
import {reactive} from "@vue/reactivity";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import GameDTO from "@/models/GameDTO";
import {onMounted} from "vue";
import {api} from "@/service/APIClient";
import {useStore} from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'Games',
  setup(__props) {

const state = reactive({
  games: {
    limit: 100,
    offset: 0,
    totalCount: 0,
    items: []
  } as PaginatedResponseDTO<GameDTO>,
});
const store = useStore();

const onFavoriteChange = (game: GameDTO) => {
  if (game.isFavorite) {
    store.dispatch('addFavoriteGame', game);
  } else {
    store.dispatch('removeFavoriteGame', game);
  }

  const item = state.games.items.find(g => g.id === game.id);
  if (item) {
    item.isFavorite = game.isFavorite
  }
}

onMounted(async () => {
  [state.games] = await Promise.all([
    api.call.games.list(state.games),
  ])
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('games')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).games.items, (game, index) => {
        return (_openBlock(), _createBlock(GameIcon, {
          onFavoriteChanged: onFavoriteChange,
          key: game.id,
          game: game
        }, null, 8, ["game"]))
      }), 128))
    ])
  ]))
}
}

})